module.exports = __webpack_public_path__ + "static/media/contact.421574a9.svg";